import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Components/Header";
import Menu from "./Components/Menu";
import { config } from "./Components/Config";
import { Modal, Dropdown } from "react-bootstrap";

const GENDER_OPTIONS = [
  { value: "MR", label: "Tuan" },
  { value: "MRS", label: "Nyonya" },
  { value: "MISS", label: "Nona" },
];

const PROCUREMENT_OPTIONS = [
  { value: "Decision Maker", label: "Pengambil Keputusan" },
  { value: "Advisor / Recommender", label: "Pemberi Rekomendasi / Pemberi Masukan" },
  { value: "User", label: "Pengguna" },
  { value: "Observer", label: "Pengamat" },
];

const SOURCE_OPTIONS = [
  { value: "E-mail", label: "E-mail" },
  { value: "WhatsApp Marketing PointStar", label: "WhatsApp Marketing PointStar" },
  { value: "WhatsApp Salesperson PointStar", label: "WhatsApp Sales Person PointStar" },
  { value: "LinkedIn PointStar Indonesia", label: "LinkedIn PointStar Indonesia" },
  { value: "Instagram PointStar Indonesia", label: "Instagram PointStar Indonesia" },
];

const EMPTY_FORM = {
  name: "",
  phone: "",
  gender: "",
  email: "",
  company: "",
  position: "",
  industry: "",
  department: "",
  procurementRole: "",
  source: "",
};

const EventContact = () => {
  const navigate = useNavigate();
  const [contacts, setContacts] = useState([]);
  const [tableSearch, setTableSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [isLoadingPage, setIsLoadingPage] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 1,
  });

  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [formData, setFormData] = useState(EMPTY_FORM);
  const [isSaving, setIsSaving] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const crmUser = JSON.parse(localStorage.getItem('crmUser'));

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearch(tableSearch), 500);
    return () => clearTimeout(timer);
  }, [tableSearch]);

  useEffect(() => {
    fetchContacts();
  }, [pagination.page, pagination.limit, debouncedSearch]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchContacts = async () => {
    setIsLoadingPage(true);
    try {
      const params = new URLSearchParams({
        page: pagination.page,
        limit: pagination.limit,
        search: debouncedSearch,
      });
      const res = await fetch(`${config.EVENT_ENDPOINT}contact?${params}`);
      const result = await res.json();
      if (result.success) {
        setContacts(result.data);
        setPagination((prev) => ({
          ...prev,
          total: result.meta?.totalItems || 0,
          totalPages: result.meta?.totalPages || 1,
        }));
      }
    } catch (err) {
      console.error("Error fetching contacts:", err);
    } finally {
      setIsLoadingPage(false);
    }
  };

  const clearSearch = () => setTableSearch("");

  const handleOpenModal = (contact = null) => {
    setEditId(contact?.id || null);
    setFormData(
      contact
        ? {
          name: contact.name || "",
          phone: contact.phone || "",
          gender: contact.gender || "",
          email: contact.email || "",
          company: contact.company || "",
          position: contact.position || "",
          industry: contact.industry || "",
          department: contact.department || "",
          procurementRole: contact.procurementRole || "",
          source: contact.source || "",
        }
        : EMPTY_FORM
    );
    setShowModal(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    try {
      const payload = {
        ...formData,
        gender: formData.gender || null,
        email: formData.email || null,
        position: formData.position || null,
        industry: formData.industry || null,
        department: formData.department || null,
        procurementRole: formData.procurementRole || null,
        source: formData.source || null,
      };

      const url = editId
        ? `${config.EVENT_ENDPOINT}contact/${editId}`
        : `${config.EVENT_ENDPOINT}contact`;

      const res = await fetch(url, {
        method: editId ? "PATCH" : "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const result = await res.json();
      if (result.success) {
        setShowModal(false);
        fetchContacts();
      } else {
        alert(result.message || "Gagal menyimpan contact");
      }
    } catch (err) {
      alert("Terjadi kesalahan");
    } finally {
      setIsSaving(false);
    }
  };

  const confirmDelete = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const handleDelete = async () => {
    try {
      const res = await fetch(`${config.EVENT_ENDPOINT}contact/${deleteId}`, {
        method: "DELETE",
      });
      const result = await res.json();
      if (result.success) {
        setShowDeleteModal(false);
        setDeleteId(null);
        fetchContacts();
      } else {
        alert(result.message || "Gagal menghapus contact");
      }
    } catch (err) {
      alert("Terjadi kesalahan");
    }
  };

  const genderLabel = (val) =>
    GENDER_OPTIONS.find((o) => o.value === val)?.label || "-";

  const renderPaginationItems = () => {
    const { page, totalPages } = pagination;
    const items = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) items.push(i);
    } else {
      if (page <= 4) {
        for (let i = 1; i <= 5; i++) items.push(i);
        items.push("...");
        items.push(totalPages);
      } else if (page >= totalPages - 3) {
        items.push(1);
        items.push("...");
        for (let i = totalPages - 4; i <= totalPages; i++) items.push(i);
      } else {
        items.push(1);
        items.push("...");
        items.push(page - 1);
        items.push(page);
        items.push(page + 1);
        items.push("...");
        items.push(totalPages);
      }
    }
    return items.map((item, index) => (
      <li key={index} className="page-item">
        {item === "..." ? (
          <span
            className="page-link border-0 text-secondary bg-transparent"
            style={{ width: "32px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center" }}
          >
            ...
          </span>
        ) : (
          <button
            className={`page-link border-0 rounded-circle d-flex align-items-center justify-content-center ${pagination.page === item ? "bg-gold text-white shadow-sm" : "text-secondary bg-transparent"}`}
            style={{ width: "32px", height: "32px" }}
            onClick={() => setPagination((prev) => ({ ...prev, page: item }))}
          >
            {item}
          </button>
        )}
      </li>
    ));
  };

  return (
    <div id="event-contact-list">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard">
                <img className="h-100" src="/cuancuan.png" alt="PointStar" />
              </a>
            </div>
            <hr className="m-0" />
            <Menu active="event-contact" />
          </div>
          <div className="col-md-10">
            <Header />
            <hr className="m-0" />
            <div className="main">
              <div className="p-4">
                <section className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="d-flex align-items-center gap-4">
                      <div className="fs-24">Contact</div>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <div className="input-group input-search">
                        <button
                          className="btn bg-white"
                          type="button"
                          onClick={clearSearch}
                        >
                          {tableSearch ? (
                            <i className="bi bi-x-lg" />
                          ) : (
                            <i className="bi bi-search" />
                          )}
                        </button>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Search"
                          value={tableSearch}
                          onChange={(e) => setTableSearch(e.target.value)}
                        />
                      </div>
                      {crmUser.user_level !== 'View' && (
                        <button
                          className="btn btn-primary bg-gold text-dark border-0"
                          type="button"
                          onClick={() => handleOpenModal()}
                        >
                          <i className="bi bi-plus-circle me-1" /> Add
                        </button>
                      )}
                    </div>
                  </div>

                  <div className="bg-white border-radius-4 p-4">
                    {isLoadingPage ? (
                      <p>Loading...</p>
                    ) : contacts.length > 0 ? (
                      <>
                        <div className="table-responsive">
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th className="bg-gold fw-bold border-0 text-start" style={{ borderTopLeftRadius: "8px" }}>#</th>
                                <th className="bg-gold fw-bold border-0 text-start">Name</th>
                                <th className="bg-gold fw-bold border-0 text-start">Greeting</th>
                                <th className="bg-gold fw-bold border-0 text-start">Phone</th>
                                <th className="bg-gold fw-bold border-0 text-start">Email</th>
                                <th className="bg-gold fw-bold border-0 text-start">Company</th>
                                {crmUser.user_level !== 'View' && (
                                  <th className="bg-gold fw-bold border-0 text-start" style={{ borderTopRightRadius: "8px" }}>Aksi</th>
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {contacts.map((c, idx) => (
                                <tr key={c.id} onClick={() => navigate(`/event/contact/${c.id}`)} style={{ cursor: "pointer" }}>
                                  <td>{(pagination.page - 1) * pagination.limit + idx + 1}</td>
                                  <td>{c.name}</td>
                                  <td>{genderLabel(c.gender)}</td>
                                  <td>{c.phone}</td>
                                  <td>{c.email || "-"}</td>
                                  <td>{c.source || "-"}</td>
                                  {crmUser.user_level !== 'View' && (
                                    <td onClick={(e) => e.stopPropagation()}>
                                      <Dropdown drop="down-centered">
                                        <Dropdown.Toggle
                                          variant="light"
                                          size="sm"
                                          className="border-0 bg-transparent text-dark shadow-none p-0"
                                          id={`dropdown-${c.id}`}
                                        >
                                          <i className="bi bi-three-dots-vertical fs-5" />
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu
                                          className="shadow-sm border-0 z-3"
                                          renderOnMount
                                          popperConfig={{ strategy: "fixed", modifiers: [{ name: "preventOverflow", options: { rootBoundary: "viewport" } }] }}
                                        >
                                          <Dropdown.Item onClick={() => handleOpenModal(c)}>
                                            <i className="bi bi-pencil-square me-2 text-warning" /> Edit
                                          </Dropdown.Item>
                                          <Dropdown.Divider />
                                          <Dropdown.Item
                                            onClick={() => confirmDelete(c.id)}
                                            className="text-danger"
                                          >
                                            <i className="bi bi-trash-fill me-2" /> Delete
                                          </Dropdown.Item>
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </td>
                                  )}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>

                        {pagination.totalPages > 0 && (
                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <div className="d-flex align-items-center gap-2 text-secondary">
                              <small>Show</small>
                              <select
                                className="form-select form-select-sm border-secondary text-secondary"
                                style={{ width: "70px", borderRadius: "4px" }}
                                value={pagination.limit}
                                onChange={(e) =>
                                  setPagination((prev) => ({ ...prev, limit: Number(e.target.value), page: 1 }))
                                }
                              >
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                                <option value={50}>50</option>
                              </select>
                              <small>entries</small>
                            </div>
                            <nav>
                              <ul className="pagination pagination-sm mb-0 gap-1">
                                <li className={`page-item ${pagination.page === 1 ? "disabled" : ""}`}>
                                  <button
                                    className="page-link border-0 text-secondary bg-transparent"
                                    onClick={() => setPagination((prev) => ({ ...prev, page: prev.page - 1 }))}
                                    disabled={pagination.page === 1}
                                  >
                                    <i className="bi bi-chevron-left" />
                                  </button>
                                </li>
                                {renderPaginationItems()}
                                <li className={`page-item ${pagination.page === pagination.totalPages ? "disabled" : ""}`}>
                                  <button
                                    className="page-link border-0 text-secondary bg-transparent"
                                    onClick={() => setPagination((prev) => ({ ...prev, page: prev.page + 1 }))}
                                    disabled={pagination.page === pagination.totalPages}
                                  >
                                    <i className="bi bi-chevron-right" />
                                  </button>
                                </li>
                              </ul>
                            </nav>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="text-center p-4">No data available</div>
                    )}
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Create / Edit Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered scrollable backdrop="static">
        <Modal.Header closeButton className="border-bottom pb-3">
          <Modal.Title className="fs-5 fw-bold text-dark">
            {editId ? "Edit Contact" : "Tambah Contact"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4 bg-white">
          <form id="contact-form" onSubmit={handleSubmit}>
            <div className="row g-4">
              <div className="col-md-12">
                <label className="form-label text-secondary fw-semibold mb-2">
                  Nama Lengkap <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Nama Lengkap"
                  className="form-control p-2"
                  required
                />
              </div>

              <div className="col-md-6">
                <label className="form-label text-secondary fw-semibold mb-2">Sapaan</label>
                <select
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  className="form-select p-2"
                >
                  <option value="">Pilih Sapaan</option>
                  {GENDER_OPTIONS.map((o) => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                  ))}
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label text-secondary fw-semibold mb-2">
                  No. Telepon (WhatsApp) <span className="text-danger">*</span>
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="08123456789"
                  inputMode="numeric"
                  className="form-control p-2"
                  required
                />
              </div>

              <div className="col-md-12">
                <label className="form-label text-secondary fw-semibold mb-2">Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="example@company.com"
                  className="form-control p-2"
                />
              </div>

              <div className="col-md-12">
                <label className="form-label text-secondary fw-semibold mb-2">
                  Nama Perusahaan <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  placeholder="Your Company"
                  className="form-control p-2"
                  required
                />
              </div>

              <div className="col-md-6">
                <label className="form-label text-secondary fw-semibold mb-2">Posisi</label>
                <input
                  type="text"
                  name="position"
                  value={formData.position}
                  onChange={handleChange}
                  placeholder="Job Title"
                  className="form-control p-2"
                />
              </div>

              <div className="col-md-6">
                <label className="form-label text-secondary fw-semibold mb-2">Industri</label>
                <input
                  type="text"
                  name="industry"
                  value={formData.industry}
                  onChange={handleChange}
                  placeholder="e.g. Tech"
                  className="form-control p-2"
                />
              </div>

              <div className="col-md-12">
                <label className="form-label text-secondary fw-semibold mb-2">Departemen</label>
                <input
                  type="text"
                  name="department"
                  value={formData.department}
                  onChange={handleChange}
                  placeholder="Departemen Anda"
                  className="form-control p-2"
                />
              </div>

              <div className="col-md-12">
                <label className="form-label text-secondary fw-semibold mb-2">
                  Tingkat Pengambilan Keputusan
                </label>
                <select
                  name="procurementRole"
                  value={formData.procurementRole}
                  onChange={handleChange}
                  className="form-select p-2"
                >
                  <option value="">Pilih Tingkat Pengambilan Keputusan</option>
                  {PROCUREMENT_OPTIONS.map((o) => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                  ))}
                </select>
              </div>

              <div className="col-md-12">
                <label className="form-label text-secondary fw-semibold mb-2">Sumber</label>
                <select
                  name="source"
                  value={formData.source}
                  onChange={handleChange}
                  className="form-select p-2"
                >
                  <option value="">Pilih Sumber</option>
                  {SOURCE_OPTIONS.map((o) => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                  ))}
                </select>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="border-top pt-3">
          <button
            type="button"
            className="btn btn-light"
            onClick={() => setShowModal(false)}
          >
            Batal
          </button>
          <button
            type="submit"
            form="contact-form"
            className="btn btn-primary bg-gold text-dark border-0"
            disabled={isSaving}
          >
            {isSaving ? "Menyimpan..." : "Simpan"}
          </button>
        </Modal.Footer>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered size="sm">
        <Modal.Header closeButton className="border-bottom pb-3">
          <Modal.Title className="fs-6 fw-bold text-dark">Hapus Contact</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-0">Yakin ingin menghapus contact ini?</p>
        </Modal.Body>
        <Modal.Footer className="border-top pt-3">
          <button
            type="button"
            className="btn btn-light"
            onClick={() => setShowDeleteModal(false)}
          >
            Batal
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleDelete}
          >
            Hapus
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default EventContact;
